var map = {
	"./acala.svg": [
		86601,
		86601
	],
	"./algorand.svg": [
		562051,
		62051
	],
	"./aptos.svg": [
		762573,
		62573
	],
	"./avalanche.svg": [
		894148,
		94148
	],
	"./axelar.svg": [
		570266,
		70266
	],
	"./biltong.svg": [
		321314,
		21314
	],
	"./cardano.svg": [
		813512,
		13512
	],
	"./celo.svg": [
		160274,
		60274
	],
	"./chainlink.svg": [
		751468,
		51468
	],
	"./cosmos.svg": [
		720305,
		20305
	],
	"./crypto_dot_com.svg": [
		796721,
		96721
	],
	"./decred.svg": [
		659232,
		59232
	],
	"./edgeware.svg": [
		780018,
		80018
	],
	"./eth2.svg": [
		64013,
		64013
	],
	"./evmos.svg": [
		771434,
		71434
	],
	"./flow.svg": [
		712032,
		12032
	],
	"./helium.svg": [
		290142,
		90142
	],
	"./jerky.svg": [
		720993,
		20993
	],
	"./karura.svg": [
		722245,
		22245
	],
	"./keep.svg": [
		324129,
		24129
	],
	"./kusama.svg": [
		906152,
		6152
	],
	"./libra.svg": [
		932359,
		32359
	],
	"./libra2.svg": [
		845412,
		45412
	],
	"./livepeer.svg": [
		811999,
		11999
	],
	"./mina.svg": [
		45150,
		45150
	],
	"./moonbeam.svg": [
		888296,
		88296
	],
	"./moonriver.svg": [
		476449,
		76449
	],
	"./near.svg": [
		607438,
		7438
	],
	"./node_blank.svg": [
		317001,
		17001
	],
	"./nucypher.svg": [
		635896,
		35896
	],
	"./oasis.svg": [
		669106,
		69106
	],
	"./ontology.svg": [
		803707,
		3707
	],
	"./polkadot.svg": [
		97273,
		97273
	],
	"./provenance.svg": [
		121107,
		93120
	],
	"./relay.svg": [
		297825
	],
	"./sentry_nodes.svg": [
		733892
	],
	"./solana.svg": [
		893426,
		93426
	],
	"./sui.svg": [
		447617,
		47617
	],
	"./terra.svg": [
		832689,
		32689
	],
	"./tezos.svg": [
		948600,
		48600
	],
	"./threshold.svg": [
		452331,
		52331
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 781004;
module.exports = webpackAsyncContext;